import NavBar from 'components/layout/navbar';
import React from 'react';
import CfyeHeaader from './CfyeHeaader';
import Impact from './Impact';
import Story from './Story';
import About from './About';
import Footer from 'components/layout/footer';

export default function Cfye() {
  return (
    <>
      {' '}
      <NavBar />
      <CfyeHeaader />
      <Impact />
      <Story />
      <About />
      <Footer />
    </>
  );
}
